<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link class="button is-info is-small" :to="{name: 'Create Client'}">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create new</router-link>
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination :placeholder="'Search Client by Name'" :tableData="clients.data" :search="search" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="clients.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column class="table-column-content-is-small" label="Company Name">
          {{item.row.companyName}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Contact Name">
          {{item.row.contactName}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Title">
          {{item.row.title}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Email">
          {{item.row.email}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Phone">
          {{item.row.phone}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Payment Method">
          {{item.row.paymentMethod}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Term">
          {{item.row.term}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Agent">
          {{item.row.agent}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Active">
          <center>
            <p v-if="item.row.isDeleted === false">Yes</p>
            <p v-else>No</p>
          </center>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <router-link class="button is-small is-warning" :to="{name: 'Edit Client', params: { clientId:item.row.clientId} }">Edit</router-link>
          &nbsp;
          <button class="button is-small is-danger" @click="deleteClient(item.row.clientId, item.row.companyName)">Delete</button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TablePagination from '../TablePagination.vue'
import Delete from './Delete.vue'

export default {
  components: {
    TablePagination,
    Delete
  },
  mounted() {
    this.default()
  },
  computed: {
    ...mapState('client', {
      clients: state => state.clients,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: ''
  }),
  methods: {
    ...mapActions('client', ['getPaginatedClients', 'openDeleteModal']),
    refreshTable() {
      this.default()
    },
    default() {
      this.getPaginatedClients({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      })
    },
    deleteClient(id, companyName) {
      this.openDeleteModal({
        showDeleteModal: true,
        client: {
          clientId: id,
          companyName: companyName
        }
      })
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedClients({
        page: this.page,
        pageSize: val,
        query: this.search
      })
    },
    page(val) {
      this.getPaginatedClients({
        page: val,
        pageSize: this.perPage,
        query: this.search
      })
    },
    search(val) {
      this.getPaginatedClients({
        page: this.page,
        pageSize: this.perPage,
        query: val
      })
    }
  }
}
</script>

